/* Garden Greens theme: age gate, nav, strain filter, store finder, contact routing, hero video, reveal.
   Ported from the concept site app.js. Storage key: gg_age (timestamp). No counts are ever printed:
   stores and strains change constantly. */
(function () {
  'use strict';
  var store = {
    get: function (k, d) { try { var v = localStorage.getItem(k); return v === null ? d : v; } catch (e) { return d; } },
    set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var Q = new URLSearchParams(location.search);

  /* ---------- age gate ---------- */
  function gate() {
    var g = $('#gate');
    if (!g) return;
    if (/^\/policies\//.test(location.pathname)) { g.hidden = true; return; } /* legal pages stay readable from the gate links */
    if (window.Shopify && Shopify.designMode) {
      /* Theme editor: keep the gate out of the way; show it only while its section is selected. */
      g.hidden = true;
      var sec = g.closest('.shopify-section');
      document.addEventListener('shopify:section:select', function (e) { if (sec && e.target === sec) g.hidden = false; });
      document.addEventListener('shopify:section:deselect', function (e) { if (sec && e.target === sec) g.hidden = true; });
      return;
    }
    var days = parseInt(g.getAttribute('data-remember-days'), 10) || 30;
    var saved = store.get('gg_age', '');
    var ts = saved === 'yes' ? Date.now() : parseInt(saved, 10);
    if (ts && Date.now() - ts < days * 86400000) { g.hidden = true; return; }
    g.hidden = false;
    document.body.style.overflow = 'hidden';
    var yes = $('#gate-yes');
    if (yes) yes.focus();
    yes.addEventListener('click', function () {
      store.set('gg_age', String(Date.now()));
      g.hidden = true;
      document.body.style.overflow = '';
    });
    $('#gate-no').addEventListener('click', function () {
      $('.gate-no', g).textContent = g.getAttribute('data-no-text') || '';
    });
    g.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var f = $$('button, a[href]', g);
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  /* ---------- nav ---------- */
  function nav() {
    var b = $('.menu-btn'), n = $('.nav');
    if (!b || !n) return;
    b.addEventListener('click', function () {
      var o = n.classList.toggle('open');
      b.setAttribute('aria-expanded', o ? 'true' : 'false');
    });
  }

  /* ---------- strains: class filter + search over the server-rendered cards ---------- */
  function strains() {
    var el = $('#strains'), pills = $$('#strain-pills .pill');
    if (!el || !pills.length) return;
    var CLS = ['all', 'indica', 'sativa', 'hybrid'];
    var f = CLS.indexOf(Q.get('f')) > -1 ? Q.get('f') : 'all', q = '';
    var status = $('#strain-status'), none = $('#strain-none');
    function draw() {
      var shown = 0;
      $$('.sc', el).forEach(function (c) {
        var ok = (f === 'all' || c.getAttribute('data-cls') === f) && (!q || (c.getAttribute('data-q') || '').indexOf(q) > -1);
        c.hidden = !ok;
        if (ok) shown++;
      });
      if (none) none.hidden = shown > 0;
      if (status) {
        var t = f === 'all' ? status.getAttribute('data-all') : status.getAttribute('data-some').replace('[class]', f);
        if (q) t = t.replace(/\.$/, '') + ' ' + status.getAttribute('data-matching').replace('[q]', q);
        status.textContent = t;
      }
    }
    pills.forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-f') === f ? 'true' : 'false');
      b.addEventListener('click', function () {
        f = b.getAttribute('data-f');
        pills.forEach(function (p) { p.setAttribute('aria-pressed', p === b ? 'true' : 'false'); });
        try { history.replaceState(null, '', f === 'all' ? location.pathname : '?f=' + f); } catch (e) {}
        draw();
      });
    });
    var inp = $('#strain-q');
    if (inp) inp.addEventListener('input', function (e) { q = e.target.value.trim().toLowerCase(); draw(); });
    draw();
  }

  /* ---------- store finder ---------- */
  var R = function (d) { return d * Math.PI / 180; };
  function miles(a, b) {
    var dl = R(b.lat - a.lat), dn = R(b.lng - a.lng);
    var h = Math.pow(Math.sin(dl / 2), 2) + Math.cos(R(a.lat)) * Math.cos(R(b.lat)) * Math.pow(Math.sin(dn / 2), 2);
    return 3958.8 * 2 * Math.asin(Math.sqrt(h));
  }
  var dirs = function (s) { return 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(s.n + ', ' + s.a + ', ' + s.c + ', NJ' + (s.z ? ' ' + s.z : '')); };
  var tel = function (p) { return 'tel:+1' + String(p).replace(/\D/g, '').slice(-10); };
  var NEWTAB = '<span class="sr"> (opens in a new tab)</span>';
  var hasPt = function (s) { return isFinite(s.lat) && isFinite(s.lng) && s.lat !== null && s.lng !== null && s.lat !== ''; };

  function loadStores(box) {
    var feed = box.getAttribute('data-feed'), fallback = box.getAttribute('data-fallback');
    function norm(d) { var a = Array.isArray(d) ? d : (d && d.stores) || []; return a.filter(function (s) { return s && s.n; }).map(function (s) { s.lat = parseFloat(s.lat); s.lng = parseFloat(s.lng); return s; }); }
    function snap() { return fetch(fallback).then(function (r) { return r.json(); }).then(norm).catch(function () { return []; }); }
    if (!feed) return snap();
    var ctl = window.AbortController ? new AbortController() : null;
    var timer = ctl ? setTimeout(function () { ctl.abort(); }, 9000) : null;
    return fetch(feed, ctl ? { signal: ctl.signal } : {}).then(function (r) { if (!r.ok) throw new Error('feed'); return r.json(); })
      .then(function (d) { if (timer) clearTimeout(timer); var s = norm(d); if (!s.length) throw new Error('empty'); return s; })
      .catch(function () { if (timer) clearTimeout(timer); return snap(); });
  }

  function finder() {
    var box = $('#finder'), list = $('#store-list');
    if (!box || !list) return;
    loadStores(box).then(function (STORES) { runFinder(box, list, STORES); });
  }

  function runFinder(box, list, STORES) {
    var want = Q.get('for');
    var forEl = $('#find-for');
    if (want && forEl) forEl.innerHTML = esc(forEl.getAttribute('data-prefix')) + ' <b>' + esc(want) + '</b>' + esc(forEl.getAttribute('data-suffix'));
    function zipPoint(z) {
      var n = +z, hit = STORES.filter(function (s) { return s.z === z && hasPt(s); });
      if (hit.length) return { lat: hit[0].lat, lng: hit[0].lng };
      var best = null, bd = 1e9;
      STORES.forEach(function (s) { var d = Math.abs(+s.z - n); if (s.z && hasPt(s) && d < bd) { bd = d; best = s; } });
      return best && bd < 60 ? { lat: best.lat, lng: best.lng } : null;
    }
    var map = null, markers = {}, origin = null;
    var pts = STORES.map(function (s, i) { return { s: s, i: i }; }).filter(function (o) { return hasPt(o.s); });
    if (window.L && $('#map')) {
      map = L.map('map', { scrollWheelZoom: false, zoomControl: true }).setView([40.25, -74.55], 8);
      L.tileLayer(box.getAttribute('data-tiles'), { attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors', maxZoom: 19 }).addTo(map);
      var icon = function (on) { return L.divIcon({ className: '', html: '<div class="pin' + (on ? ' on' : '') + '"></div>', iconSize: [20, 34], iconAnchor: [10, 32], popupAnchor: [0, -28] }); };
      pts.forEach(function (o) {
        var s = o.s;
        var m = L.marker([s.lat, s.lng], { icon: icon(false), title: s.n + ', ' + s.c, alt: s.n }).addTo(map)
          .bindPopup('<b>' + esc(s.n) + '</b>' + esc(s.a) + ', ' + esc(s.c) + (s.p ? '<br><a href="' + tel(s.p) + '">' + esc(s.p) + '</a>' : '')
            + (s.w ? '<br><a class="btn green sm" href="' + esc(s.w) + '" target="_blank" rel="noopener">Shop Garden Greens' + NEWTAB + '</a>' : '')
            + '<br><a href="' + dirs(s) + '" target="_blank" rel="noopener">Directions' + NEWTAB + '</a>');
        m.on('click', function () { select(o.i, false); });
        markers[o.i] = m;
      });
      markers.icon = icon;
      if (pts.length) map.fitBounds(pts.map(function (o) { return [o.s.lat, o.s.lng]; }), { padding: [24, 24] });
    }
    function select(i, fly) {
      $$('.store', list).forEach(function (r) { r.classList.toggle('on', +r.getAttribute('data-i') === i); });
      if (!map) return;
      Object.keys(markers).forEach(function (k) { if (k !== 'icon') markers[k].setIcon(markers.icon(+k === i)); });
      if (fly && markers[i]) { map.flyTo([STORES[i].lat, STORES[i].lng], 13, { duration: 0.8 }); markers[i].openPopup(); }
      var row = $('.store[data-i="' + i + '"]', list); if (row && !fly) row.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
    function draw(filter) {
      var r = STORES.map(function (s, i) { return { s: s, i: i, d: origin && hasPt(s) ? miles(origin, s) : null }; });
      if (filter) r = r.filter(function (o) { return (o.s.n + ' ' + o.s.c + ' ' + o.s.z + ' ' + o.s.a).toLowerCase().indexOf(filter) > -1; });
      if (origin) { r = r.filter(function (o) { return o.d !== null; }); r.sort(function (a, b) { return a.d - b.d; }); }
      list.innerHTML = r.slice(0, origin ? 40 : 1000).map(function (o) {
        return '<div class="store" data-i="' + o.i + '"><div class="store-top"><div><h2>' + esc(o.s.n) + '</h2><p>' + esc(o.s.a) + ', ' + esc(o.s.c) + (o.s.z ? ' ' + esc(o.s.z) : '') + '</p>'
          + (o.s.p ? '<p><a href="' + tel(o.s.p) + '">' + esc(o.s.p) + '</a></p>' : '') + '</div>' + (o.d !== null ? '<span class="mi">' + o.d.toFixed(1) + ' mi</span>' : '') + '</div>'
          + '<div class="store-act">' + (o.s.w ? '<a class="btn green" href="' + esc(o.s.w) + '" target="_blank" rel="noopener">Shop Garden Greens<span class="sr"> at ' + esc(o.s.n) + ', ' + esc(o.s.c) + ' (opens in a new tab)</span></a>' : '')
          + '<a href="' + dirs(o.s) + '" target="_blank" rel="noopener">Directions<span class="sr"> to ' + esc(o.s.n) + ' (opens in a new tab)</span></a>'
          + (hasPt(o.s) ? '<button type="button" class="map-btn">Show on map<span class="sr"> ' + esc(o.s.n) + '</span></button>' : '') + '</div></div>';
      }).join('') || '<p class="none">No shops match that search. Try a nearby town or ZIP.</p>';
      $$('.store', list).forEach(function (row) {
        var go = function () { select(+row.getAttribute('data-i'), true); };
        row.addEventListener('click', function (e) { if (!e.target.closest('a')) go(); });  /* row is mouse-clickable; keyboard users use the Show on map button */
      });
      $('#find-res').textContent = origin ? 'Closest shops first.' : filter ? (r.length ? 'Shops matching "' + filter + '".' : '') : 'Every New Jersey dispensary that carries Garden Greens.';
      if (map && origin) {
        var near = r.slice(0, 6).map(function (o) { return [o.s.lat, o.s.lng]; }); near.push([origin.lat, origin.lng]);
        map.fitBounds(near, { padding: [40, 40], maxZoom: 12 });
      }
    }
    $('#find-form').addEventListener('submit', function (e) {
      e.preventDefault();
      var v = $('#find-q').value.trim();
      if (/^\d{5}$/.test(v)) {
        origin = zipPoint(v);
        if (!origin) { $('#find-res').textContent = 'That ZIP looks like it is outside New Jersey. Try a NJ ZIP or a town name.'; return; }
        draw('');
      } else {
        origin = null; draw(v.toLowerCase());
        if (map && v) {
          var hits = STORES.filter(function (s) { return hasPt(s) && (s.n + ' ' + s.c).toLowerCase().indexOf(v.toLowerCase()) > -1; });
          if (hits.length) map.fitBounds(hits.map(function (s) { return [s.lat, s.lng]; }), { padding: [40, 40], maxZoom: 13 });
        }
      }
    });
    $('#loc-btn').addEventListener('click', function () {
      if (!navigator.geolocation) { $('#find-res').textContent = 'Location is not available in this browser.'; return; }
      $('#find-res').textContent = 'Finding you...';
      navigator.geolocation.getCurrentPosition(function (p) { origin = { lat: p.coords.latitude, lng: p.coords.longitude }; draw(''); },
        function () { $('#find-res').textContent = 'Could not get your location. Enter a ZIP instead.'; }, { timeout: 8000 });
    });
    var z = Q.get('zip');
    if (z) { $('#find-q').value = z; $('#find-form').dispatchEvent(new Event('submit', { cancelable: true })); }
    else draw('');
  }

  /* ---------- hero: plays the facility video only when a source exists, never for reduced-motion visitors ---------- */
  function heroVideo() {
    var v = $('.hero-video');
    if (!v || !v.querySelector('source')) return;
    if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    v.hidden = false;
    v.addEventListener('playing', function () { v.closest('.hero').classList.add('has-video'); }, { once: true });
    var p = v.play(); if (p && p.catch) p.catch(function () { v.hidden = true; });
  }

  /* ---------- contact: Sales shows the dispensary field (inboxes are routed server side, never shown) ---------- */
  function contactRouting() {
    var sel = $('#c-topic');
    if (!sel) return;
    var shop = $('#c-shop-fld');
    function sync() {
      var o = sel.selectedOptions[0];
      if (shop) shop.hidden = !(o && o.getAttribute('data-key') === 'sales');
    }
    sel.addEventListener('change', sync);
    var t = Q.get('topic');
    if (t) {
      $$('option', sel).forEach(function (o) { if (o.getAttribute('data-key') === t) sel.value = o.value; });
    }
    sync();
  }

  function forms() {
    var ok = $('.ok.on[data-focus-on-load]');
    if (ok) ok.focus();
  }

  function reveal() {
    var els = $$('.rv:not(.in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- announcements carousel: autoplay pauses on hover, focus, the pause button, and reduced motion ---------- */
  function announcements(root) {
    $$('[data-ann]', root || document).forEach(function (el) {
      if (el._ann) return; el._ann = 1;
      var slides = $$('.ann-slide', el), dots = $$('.ann-dot', el);
      if (slides.length < 2) return;
      var track = $('.ann-track', el);
      var i = 0, timer = 0, hold = 0, ms = parseInt(el.getAttribute('data-ms'), 10) || 7000;
      var pauseBtn = $('[data-ann-pause]', el);
      var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var stopped = still;
      function show(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.hidden = k !== i; s.classList.toggle('on', k === i); });
        dots.forEach(function (d, k) { d.classList.toggle('on', k === i); if (k === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
      }
      function tick() { clearTimeout(timer); if (!stopped && !hold) timer = setTimeout(function () { show(i + 1); tick(); }, ms); }
      function setStopped(v) { stopped = v; el.classList.toggle('paused', v); if (pauseBtn) { pauseBtn.setAttribute('aria-pressed', v ? 'true' : 'false'); pauseBtn.setAttribute('aria-label', v ? 'Play announcements' : 'Pause announcements'); } tick(); }
      var prev = $('[data-ann-prev]', el), next = $('[data-ann-next]', el);
      if (prev) prev.addEventListener('click', function () { show(i - 1); tick(); });
      if (next) next.addEventListener('click', function () { show(i + 1); tick(); });
      dots.forEach(function (d) { d.addEventListener('click', function () { show(parseInt(d.getAttribute('data-ann-go'), 10)); tick(); }); });
      if (pauseBtn) pauseBtn.addEventListener('click', function () { setStopped(!stopped); });
      el.addEventListener('mouseenter', function () { hold = 1; tick(); });
      el.addEventListener('mouseleave', function () { hold = 0; tick(); });
      el.addEventListener('focusin', function () { hold = 1; tick(); });
      el.addEventListener('focusout', function (e) { if (!el.contains(e.relatedTarget)) { hold = 0; tick(); } });
      /* Hold the strip at the height of its tallest slide so the page below never jumps between slides. */
      function fit() {
        if (!track) return;
        track.style.minHeight = '';
        var h = 0;
        slides.forEach(function (s, k) { slides.forEach(function (x, j) { x.hidden = j !== k; }); h = Math.max(h, s.offsetHeight); });
        show(i);
        track.style.minHeight = h + 'px';
      }
      var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(fit, 150); });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
      $$('img', el).forEach(function (im) { if (!im.complete) im.addEventListener('load', fit, { once: true }); });
      fit();
      /* Theme editor: selecting an announcement block shows that slide and holds it. */
      el.addEventListener('shopify:block:select', function (e) { var k = slides.indexOf(e.target); if (k > -1) { hold = 1; show(k); tick(); } });
      el.addEventListener('shopify:block:deselect', function () { hold = 0; tick(); });
      setStopped(stopped);
    });
  }

  /* ---------- strain page photos: swipe, arrows, thumbnails ---------- */
  function strainGallery() {
    $$('[data-gal]').forEach(function (g) {
      var track = $('.sd-track', g), thumbs = $$('.sd-thumbs button', g), n = $$('img', track).length;
      var smooth = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      function at() { return Math.round(track.scrollLeft / (track.clientWidth || 1)); }
      function go(i) { i = (i + n) % n; track.scrollTo({ left: i * track.clientWidth, behavior: smooth }); mark(i); }
      function mark(i) { thumbs.forEach(function (b, k) { if (k === i) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current'); }); }
      var t;
      track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(function () { mark(at()); }, 80); });
      thumbs.forEach(function (b, k) { b.addEventListener('click', function () { go(k); }); });
      $$('.sd-nav', g).forEach(function (b) { b.addEventListener('click', function () { go(at() + +b.getAttribute('data-step')); }); });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); go(at() + (e.key === 'ArrowRight' ? 1 : -1)); }
      });
    });
  }

  function init() { gate(); nav(); strains(); strainGallery(); heroVideo(); contactRouting(); forms(); reveal(); announcements(); }
  /* Theme editor: sections Cam adds or edits re-render, so wire them up again (reveal-on-scroll would otherwise leave them invisible). */
  document.addEventListener('shopify:section:load', function (e) { announcements(e.target); reveal(); });
  function initFinder() { finder(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  /* Leaflet loads deferred after this file, so wait for the document to finish before the map starts. */
  if (document.readyState === 'complete') initFinder(); else document.addEventListener('DOMContentLoaded', initFinder);
})();

/* ---------- signup popup ----------
   Opens on the first of: scroll depth (data-scroll %), or the visitor's Nth page view this session (data-views).
   Never while the 21+ gate is open. Dismissed: quiet for data-days. Submitted: never again.
   Storage keys: gg_su_done (localStorage), gg_su_dismiss (localStorage timestamp), gg_pv (sessionStorage page-view count).
   data-mode="demo" shows the success state locally; "shopify" posts the real Shopify customer form. */
(function () {
  'use strict';
  var el = document.getElementById('su');
  if (!el) return;
  if (window.Shopify && window.Shopify.designMode) return; /* theme editor: never pop over the preview */
  if (/^\/policies\//.test(location.pathname)) return; /* legal pages stay readable */
  var card = el.querySelector('.su-card'), form = el.querySelector('form'), main = el.querySelector('.su-main'), ok = el.querySelector('.su-ok');
  var mode = el.getAttribute('data-mode') || 'demo';
  var PCT = parseFloat(el.getAttribute('data-scroll')) || 80;
  var VIEWS = parseInt(el.getAttribute('data-views'), 10) || 2;
  var DAYS = parseFloat(el.getAttribute('data-days')); if (isNaN(DAYS)) DAYS = 14;
  var gate = document.getElementById('gate');
  var shown = false, timer = 0, lastFocus = null, prevOverflow = '';
  function ls(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) {} return null; }
  function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) {} return null; }

  var views = (parseInt(ss('gg_pv'), 10) || 0) + 1;
  ss('gg_pv', String(views));

  function eligible() {
    if (ls('gg_su_done')) return false;
    var d = parseInt(ls('gg_su_dismiss'), 10);
    return !(d && Date.now() - d < DAYS * 86400000);
  }
  function gateOpen() { return !!(gate && !gate.hidden); }
  function scrolled() {
    var de = document.documentElement, max = de.scrollHeight - window.innerHeight;
    if (max < 40) return false;
    return (window.pageYOffset || de.scrollTop) / max >= PCT / 100;
  }
  function evaluate() {
    if (shown || !eligible() || gateOpen()) return;
    if (scrolled()) { open(); return; }
    if (views >= VIEWS && !timer) {
      timer = setTimeout(function () { timer = 0; if (!shown && eligible() && !gateOpen()) open(); }, 1500);
    }
  }

  function focusables() {
    return Array.prototype.slice.call(card.querySelectorAll('button, a[href], input, select, textarea')).filter(function (n) {
      return !n.disabled && n.type !== 'hidden' && (n.offsetWidth || n.offsetHeight || n.getClientRects().length) && n.getAttribute('aria-hidden') !== 'true';
    });
  }
  function open(posted) {
    if (shown) return;
    shown = true;
    lastFocus = document.activeElement;
    prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    el.hidden = false;
    var target = posted ? ok : card;
    if (posted) card.setAttribute('aria-labelledby', 'su-ok-h');
    (target || card).setAttribute('tabindex', '-1');
    (target || card).focus();
    document.addEventListener('keydown', onKey, true);
  }
  function close(dismissed) {
    if (!shown) return;
    shown = false;
    el.hidden = true;
    document.body.style.overflow = gateOpen() ? 'hidden' : prevOverflow;
    document.removeEventListener('keydown', onKey, true);
    if (dismissed && !ls('gg_su_done')) ls('gg_su_dismiss', String(Date.now()));
    if (lastFocus && document.contains(lastFocus) && lastFocus.focus) lastFocus.focus();
  }
  function onKey(e) {
    if (e.key === 'Escape') { e.preventDefault(); close(true); return; }
    if (e.key !== 'Tab') return;
    var f = focusables();
    if (!f.length) { e.preventDefault(); card.focus(); return; }
    var first = f[0], last = f[f.length - 1], a = document.activeElement;
    if (!card.contains(a) || a === card) { e.preventDefault(); (e.shiftKey ? last : first).focus(); }
    else if (e.shiftKey && a === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
  }
  Array.prototype.forEach.call(el.querySelectorAll('[data-su-close]'), function (b) { b.addEventListener('click', function () { close(true); }); });
  el.addEventListener('mousedown', function (e) { if (e.target === el) close(true); });

  /* ----- form ----- */
  function digits(v) { var d = String(v || '').replace(/\D/g, ''); if (d.length === 11 && d.charAt(0) === '1') d = d.slice(1); return d.slice(0, 10); }
  function fmt(d) { return d.length < 4 ? d : d.length < 7 ? '(' + d.slice(0, 3) + ') ' + d.slice(3) : '(' + d.slice(0, 3) + ') ' + d.slice(3, 6) + '-' + d.slice(6); }
  var fFirst, fLast, fEmail, fPhone, fAge;
  if (form) {
    fFirst = form.querySelector('[data-f="first"]'); fLast = form.querySelector('[data-f="last"]'); fEmail = form.querySelector('[data-f="email"]');
    fPhone = form.querySelector('[data-f="phone"]'); fAge = form.querySelector('[data-f="age"]');
    if (fPhone) fPhone.addEventListener('input', function () { var v = fmt(digits(fPhone.value)); if (v !== fPhone.value) fPhone.value = v; });
  }
  function setErr(input, msg) {
    var p = document.getElementById(input.getAttribute('aria-describedby'));
    if (p) p.textContent = msg || '';
    if (msg) input.setAttribute('aria-invalid', 'true'); else input.removeAttribute('aria-invalid');
  }
  function validate() {
    var bad = null;
    function chk(input, ok_, msg) { setErr(input, ok_ ? '' : msg); if (!ok_ && !bad) bad = input; }
    chk(fFirst, fFirst.value.trim().length > 0, 'Enter your first name.');
    if (fLast) chk(fLast, fLast.value.trim().length > 0, 'Enter your last name.');
    chk(fEmail, /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(fEmail.value.trim()), 'Enter a valid email address.');
    chk(fPhone, digits(fPhone.value).length === 10, 'Enter a 10 digit US phone number.');
    chk(fAge, fAge.checked, 'Check the box to continue.');
    if (bad) bad.focus();
    return !bad;
  }
  function showSuccess() {
    ls('gg_su_done', '1');
    if (main) main.hidden = true;
    if (ok) { ok.classList.add('on'); ok.setAttribute('tabindex', '-1'); card.setAttribute('aria-labelledby', 'su-ok-h'); ok.focus(); }
  }
  if (form && mode === 'demo') {
    form.addEventListener('submit', function (e) { e.preventDefault(); if (validate()) showSuccess(); });
  } else if (form) {
    /* Shopify: validate on the button click so an invalid form never reaches the submit (or the forms backup mirror). */
    var btn = form.querySelector('button[type=submit]');
    if (btn) btn.addEventListener('click', function (e) {
      if (!validate()) { e.preventDefault(); return; }
      var d = '+1' + digits(fPhone.value);
      form.querySelector('[name="contact[phone]"]').value = d;
      form.querySelector('[name="contact[note]"]').value = 'Popup signup. Phone ' + d + '. Agreed to emails and texts on ' + new Date().toISOString().slice(0, 10) + '.';
    });
  }

  /* ----- start ----- */
  function start() {
    if (el.querySelector('[data-posted="true"]')) { ls('gg_su_done', '1'); var go = function () { if (!gateOpen()) open(true); }; go(); if (!shown && gate && window.MutationObserver) { var po = new MutationObserver(function () { if (!shown && !gateOpen()) { open(true); po.disconnect(); } }); po.observe(gate, { attributes: true, attributeFilter: ['hidden'] }); } return; }
    if (el.querySelector('#su-server-errors')) { if (!gateOpen()) open(); }
    window.addEventListener('scroll', evaluate, { passive: true });
    window.addEventListener('resize', evaluate);
    if (gate && window.MutationObserver) new MutationObserver(evaluate).observe(gate, { attributes: true, attributeFilter: ['hidden'] });
    evaluate();
  }
  /* run after the page's own init so the age gate has already decided whether to show */
  function boot() { setTimeout(start, 0); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
